import { z } from 'zod';
// UUIDv4 or v7 — Postgres `gen_random_uuid()` emits v4; our app prefers v7 for time-ordering.
// Either is acceptable on the wire.
export const UUIDSchema = z
    .string()
    .uuid('Invalid UUID');
// Opaque cursor used for pagination — base64(JSON({ id, created_at }))
export const CursorSchema = z.string().min(1).max(2048);
//# sourceMappingURL=ids.js.map